import { Text, Html, ContactShadows, PresentationControls, Environment, useGLTF, Float } from '@react-three/drei'
import React, { useState, useRef, useMemo } from 'react'
import { useFrame, useThree } from '@react-three/fiber'
import { Vector2, Raycaster } from 'three'
import { useSpring, animated } from 'react-spring';


export default function Experience()
{

    const screenRef = useRef()
    const [hovered, setHovered] = useState(false)
    const raycaster = new Raycaster()
    const mouse = new Vector2()
    const { camera } = useThree()

    const handlePointerMove = (e) => {
       
        
        mouse.x = (e.clientX / window.innerWidth) * 2 - 1
        mouse.y = -(e.clientY / window.innerHeight) * 2 + 1

        raycaster.setFromCamera(mouse, camera)
        const intersects = raycaster.intersectObject(screenRef.current)

        

        setHovered(intersects.length > 0)
    }

    useFrame(() => {
        if (hovered) {
            // screenRef.current.scale.set(1.1, 1.1, 1.1)
            // screenRef.current.rotation.y = -1.0
        } else {
            // screenRef.current.scale.set(1, 1, 1)
            // screenRef.current.rotation.y = 0
        }
    })

    

    


    const computer = useGLTF('./model.gltf')
    return <>

        <Environment preset="city" />
        <color attach="background" args={['#241a1a']} />
   
        <PresentationControls
            global
            rotation={ [ 0.13, 0.1, 0]}
            polar={ [ -0.4, 0.2]}
            azimuth={ [ -1, 0.75 ]}
            config={ {mass: 2, tension: 400 }}
            snap={ {mass:4, tension: 400} }
        >
            <Float rotationIntensity={ 0.4 }>
                <rectAreaLight 
                    width={ 2.5 }
                    height={ 1.65 }
                    intensity={ 65 }
                    color={'#ff6900'}
                    rotation={ [0.1, Math.PI, 0] }
                    position={ [0, 0.55, -1.15] }
                />
                <primitive 
                    object={computer.scene} 
                    position-y={-1.2}
                    ref={ screenRef }
                    onPointerOver={ handlePointerMove }
                    onPointerOut={ () => setHovered(false) }
                >
                <Html
                    transform
                    wrapperClass='htmlScreen'
                    distanceFactor={ 1.17}
                    position={[0, 1.56, -1.4]}
                    rotation-x={ -0.256}
                >
                    <iframe src='https://jineshb.me' />
                </Html>
            </primitive >

            <Text
                font = './bangers-v20-latin-regular.woff'
                fontSize={ 1}
                position={ [2, 0.75, 0.75] }
                rotation-y={ -1.25 }
                maxWidth={4 }
                textAlign='center'
            >So much extra</Text>
                
            </Float>
        </PresentationControls>
        <ContactShadows
            position-y = {-1.6}
            opacity={0.5}
            scale={ 5 }
            blur={ 2.4 }
        >

        </ContactShadows>

    </>
}